import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from "nprogress"
import "nprogress/nprogress.css"
import Home from '../views/landing/Home.vue'
import store from '@/store/index'
import homeLayout from "@/layouts/homeLayout";
import homePageRoutes from "@/router/routes/homePageRoutes";
import superAdminLayout from "@/layouts/superAdminLayout";
import superAdminRoutes from "@/router/routes/superAdminRoutes";
import memberLayout from "@/layouts/memberLayout";
import memberRoutes from "@/router/routes/memberRoutes";
import middlewarePipeline from "@/router/middleware/middlewarePipeline";
import auth from "@/router/middleware/auth";
import guest from "@/router/middleware/guest";
import admin from "@/router/middleware/admin";
import member from "@/router/middleware/member";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: homeLayout,
        children: [
            ...homePageRoutes
        ],
        meta: {
            middleware: [
                guest
            ]
        },
    },
    {
        path: '/super-admin',
        component: superAdminLayout,
        children: [
            ...superAdminRoutes
        ],
        meta: {
            middleware: [
                auth, admin
            ]
        },
    },
    {
        path: '/members',
        component: memberLayout,
        children: [
            ...memberRoutes
        ],
        meta: {
            middleware: [
                auth,member
            ]
        },
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    linkActiveClass: 'active'
})
router.beforeEach((to, from, next) => {
    NProgress.start();
    const nearestWithMiddleware = to.matched.slice().reverse().find(r => r.meta && r.meta.middleware);
    if (!nearestWithMiddleware) {
        return next()
    }
    const middleware = nearestWithMiddleware.meta.middleware;

    const context = {
        to,
        from,
        next,
        store
    };
    return middleware[0]({
        ...context,
        next: middlewarePipeline(context, middleware, 1)
    });
});

router.afterEach((to, from) => {
    NProgress.done();
});

export default router
